import { PatientCareProviderModel } from "one-card-pcp";
 
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * pcp Component
 * @param response has the backend
 * pcp response
 * @param context has settings etc..
 */
 
export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
 
    let pdata: PatientCareProviderModel[] = [];
 
    let result :any = {
        pcp:pdata,
        error:undefined
 
    }
    const { log } = context;
 
    if (response && (response?.success === 'true')) {
       result.error=response;
    }
  // if (response && response?.length > 0) {
    let pcparray: any = [];
    console.log("one-epics response [pcp][response]::",response);
    if(response && response?.length>0){
      response?.forEach((resp: any) => {
        if (resp?.PCPs?.length > 0) {
          resp?.PCPs?.forEach((pcpinfo: any) => {
            let pcpobj: any = {
              name: "",
 
              center: "",
 
              department: [],
            };
 
            pcpobj.name = pcpinfo?.Name ? pcpinfo.Name : "";
 
            pcpobj.center = pcpinfo?.Type ? pcpinfo.Type : "";
 
            if (pcpinfo?.Departments?.length > 0) {
              var deptarray: any = [],
                locationarray: any = [];
 
              pcpinfo.Departments.forEach((deptdata: any, index: number) => {
                let deptobj: any = {
                  id: 0,
 
                  deptname: "",
 
                  location: [],
                };
 
                deptobj.id = index + 1;
 
                deptobj.deptname = deptdata?.Name;
 
                  if (deptdata?.Locations?.length > 0) {
                      const locationNames = deptdata.Locations.map((location: any) => location.Name);
                      deptobj.location = locationNames.map((locationName: any) => ({
                          id: index + 1, // Assuming the ID is always "Revenue" based on the provided data
                          locname: locationName,
                      }));
                  }
                deptarray.push(deptobj);
              });
              pcpobj.department = deptarray;
            }
 
            pcparray.push(pcpobj);
          });
        }
    });
    }
    pdata = pcparray;
    // }
 
  result.pcp = pdata;
 
    log.debug(
        "ccw-gadget,pcp-epic",
        "pcp-epic transforamtion response ",{
            result,
        });
    return result;
};